/** OAuth コールバックで受け取った JWT を保存 */
export function storeAuthToken(token) {
  if (!token) return false;
  try {
    localStorage.setItem('auth_token', token);
    return true;
  } catch {
    return false;
  }
}

/** URL の hash または search から token を抽出 */
export function extractTokenFromUrl(urlString) {
  if (!urlString) return null;
  try {
    const url = new URL(urlString);
    if (url.hash && url.hash.startsWith('#token=')) {
      return decodeURIComponent(url.hash.slice('#token='.length));
    }
    const fromQuery = url.searchParams.get('token');
    if (fromQuery) return fromQuery;
  } catch {
    // urakarte://auth/success#token=... は URL コンストラクタでパース可能
    const hashMatch = urlString.match(/#token=([^&]+)/);
    if (hashMatch) return decodeURIComponent(hashMatch[1]);
  }
  return null;
}

/** 現在のページ hash から token を取得（Web OAuth 戻り） */
export function extractTokenFromLocationHash() {
  if (typeof window === 'undefined') return null;
  if (!window.location.hash.startsWith('#token=')) return null;
  return decodeURIComponent(window.location.hash.slice('#token='.length));
}
